import { api } from "@/lib/apiClient";
import type { OpenInvoiceBucket, OpenInvoiceCustomer } from "@/lib/heroDocumentReports";

export type OffenerPostenQuelle = "app" | "hero";
export type OffenerPostenZahlungsstatus = "offen" | "teilbezahlt" | "bezahlt";

export interface OffenerPostenItem {
  id: string;
  quelle: OffenerPostenQuelle;
  dokument_id: number | null;
  hero_document_id: number | null;
  dokument_nummer: string | null;
  rechnung_art: string | null;
  dokument_typ_label: string;
  status: string | null;
  status_label: string;
  zahlungsstatus: OffenerPostenZahlungsstatus;
  kunde: string;
  kunden_id: number | null;
  auftrag_id: number | null;
  auftragsnummer: string | null;
  beschreibung: string | null;
  betreff: string | null;
  belegdatum: string | null;
  faelligkeitsdatum: string | null;
  days_overdue: number | null;
  bucket: OpenInvoiceBucket;
  summe_brutto: number;
  summe_bezahlt: number;
  summe_offen: number;
  mahnstufe: string | null;
  mahnstufe_label: string | null;
  mahnung_pausiert: boolean;
}

export interface OffenePostenSummary {
  open_count: number;
  open_amount: number;
  brutto_amount: number;
  bezahlt_amount: number;
  overdue_count: number;
  overdue_amount: number;
  not_due_count: number;
  not_due_amount: number;
  buckets: Record<OpenInvoiceBucket, { count: number; amount: number }>;
}

export interface OffenePostenReport {
  as_of: string;
  last_synced_at: string | null;
  summary: OffenePostenSummary;
  items: OffenerPostenItem[];
  by_customer: OpenInvoiceCustomer[];
}

export async function fetchOffenePosten(): Promise<OffenePostenReport> {
  return api.get<OffenePostenReport>("/dokumente/offene-posten");
}
